import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import { ApplicationApi, ApplicationTemplateApi } from "../../../../../../../../../../services/Api/Organization/types";
import { AppModalViewMode, AppState } from "../../../../utils/types";
import AppModalBodyNav from "./AppModalBodyNav";
import AppModalBodyRoutes from "./AppModalBodyRoutes";
import AppChatCard from "./Cards/AppChatCard";
import AppInfoCard from "./Cards/AppInfoCard";

interface Props {
	installedApp?: ApplicationApi;
	viewType?: AppModalViewMode;
	configApp: ApplicationTemplateApi;
	routeProps?: RouteComponentProps;
	appState: AppState | undefined;
	setAppConfigForInstallationModal: React.Dispatch<React.SetStateAction<ApplicationTemplateApi | undefined>>;
	handleUpdateNewInstalledApp?: (app: ApplicationApi) => void;
	setAppState: React.Dispatch<React.SetStateAction<AppState | undefined>>;
	setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
	handleUninstall?: (app: ApplicationApi) => void;
	handleUpdate?: (app: ApplicationApi) => void;
	fetchApplication: () => Promise<void>;
	setShowParentModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const setView = (configApp: ApplicationTemplateApi, installedApp?: ApplicationApi) => {
	if (configApp.long_description) {
		return AppModalViewMode.DESCRIPTION;
	}
	if (configApp.help_description) {
		return AppModalViewMode.START;
	}
	if (!installedApp && !configApp.long_description && !configApp.help_description) {
		return AppModalViewMode.EMPTY;
	}
	return AppModalViewMode.FORM;
};

const AppModalBody = ({
	installedApp,
	viewType,
	configApp,
	routeProps,
	appState,
	setAppConfigForInstallationModal,
	handleUpdateNewInstalledApp,
	setAppState,
	setShowModal,
	handleUninstall,
	handleUpdate,
	fetchApplication,
	setShowParentModal,
}: Props) => {
	const [viewMode, setViewMode] = useState<AppModalViewMode>(
		viewType ? AppModalViewMode.FORM : setView(configApp, installedApp)
	);
	const { t } = useTranslation();

	return (
		<Modal.Body>
			<div className={"app-modal-content flex-md-row flex-column-reverse"}>
				<div className={"col-md-8 col-12"}>
					<div className={"content"}>
						<div className={"content-navigation"}>
							<AppModalBodyNav
								configApp={configApp}
								viewMode={viewMode}
								setViewMode={setViewMode}
								installedApp={installedApp}
								routeProps={routeProps}
							/>
							<AppModalBodyRoutes
								appState={appState}
								viewMode={viewMode}
								installedApp={installedApp}
								routeProps={routeProps}
								configApp={configApp}
								handleUpdate={handleUpdate}
								setAppState={setAppState}
								fetchApplication={fetchApplication}
							/>
						</div>
					</div>
				</div>
				<div className={"col-md-4 col-12"}>
					<AppInfoCard
						configApp={configApp}
						appState={appState}
						installedApp={installedApp}
						routeProps={routeProps}
						setAppConfigForInstallationModal={setAppConfigForInstallationModal}
						handleUpdateNewInstalledApp={handleUpdateNewInstalledApp}
						setAppState={setAppState}
						setShowModal={setShowModal}
						handleUninstall={handleUninstall}
						handleUpdate={handleUpdate}
						setShowParentModal={setShowParentModal}
					/>
					<AppChatCard />
					<div className={"d-flex flex-column"}>
						{configApp.rules_link && (
							<a target={"_blank"} rel={"noreferrer"} href={configApp.rules_link}>
								{t("modules.app.field.rules.title")}
							</a>
						)}
						{configApp.privacy_policy_link && (
							<a target={"_blank"} rel={"noreferrer"} href={configApp.privacy_policy_link}>
								{t("modules.app.field.privacy_policy.title")}
							</a>
						)}
					</div>
				</div>
			</div>
		</Modal.Body>
	);
};

export default AppModalBody;
